import { useEffect, useState } from "react";
import { COUPLE } from "../constants/site";

const TARGET = new Date(COUPLE.weddingDateISO).getTime();

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown() {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, TARGET - now);

  if (diff === 0) {
    return (
      <p className="font-script text-4xl text-sage-dark" data-testid="countdown-done">
        Chegou o grande dia!
      </p>
    );
  }

  const units = [
    { v: pad(Math.floor(diff / 86400000)), l: "Dias", id: "countdown-days" },
    { v: pad(Math.floor(diff / 3600000) % 24), l: "Horas", id: "countdown-hours" },
    { v: pad(Math.floor(diff / 60000) % 60), l: "Minutos", id: "countdown-minutes" },
    { v: pad(Math.floor(diff / 1000) % 60), l: "Segundos", id: "countdown-seconds" },
  ];

  return (
    <div className="grid grid-cols-4 gap-2.5 sm:gap-3" data-testid="countdown">
      {units.map((u) => (
        <div key={u.id} className="gold-frame border-sage/40 bg-paper px-1 py-3 sm:py-4">
          <p className="font-serif text-3xl text-ink sm:text-4xl" data-testid={u.id}>
            {u.v}
          </p>
          <p className="mt-1 font-sans text-[9px] uppercase tracking-[0.28em] text-sage-dark sm:text-[10px]">{u.l}</p>
        </div>
      ))}
    </div>
  );
}
